import React from "react";
import Select from "react-select";
import "../styles/DropDownColumns.css";

const DropdownColumnFilter = (props) => {
  let {label,value,options,onFilterChange} = props;

  // const defaultValue = value ? {label: value,value} : null;
  const defaultValue = options.find(opt => opt.value === value) || null;
  
  return (
    <div className="dropdown-column-row">
      <Select
        options={options}
        isClearable
        value={defaultValue}
        onChange={(selectedOption) =>
          onFilterChange(selectedOption ? selectedOption.value : "")
        }
        placeholder={`${label}`}
        isSearchable
        className="dropdown-column-filter"
        classNamePrefix="dropdown"
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
};

export default DropdownColumnFilter;
